import { useCallback, useState } from 'react';
export var useDatePicker = function useDatePicker(_ref) {
  var initDate = _ref.initDate,
      selectRange = _ref.selectRange;

  var _useState = useState(initDate),
      value = _useState[0],
      setValue = _useState[1];

  var onChange = useCallback(function (date) {
    setValue(date);
  }, []);
  return {
    value: value,
    onChange: onChange,
    selectRange: selectRange
  };
};